import React, { useEffect } from 'react';
import { logUI } from "../../api/andyliticsApi";
import GenericCollapseWithChildren from "../common/GenericCollapseWithChildren";
import SchedulingQuestions from './SchedulingQuestions'
import * as Tools from "../../helpers/Tools";
import InHomeFaq from './InHomeFaq'


const InHomeInEligibility = ({history}) => {
    useEffect(() => {
        logUI(`MBHWeb.UI.InHomeInEligibility.Displayed`, new Date(), Tools.getURLPath());
    }, []);
   
    return (
        <div className="container-fluid body-content inhome inhome-landing-in-eligiblity-container">
            <div className="row">
                <div className="col-12 maxWidth-content">
                    <div className="row">
                        <div className="col-12">
                            <h1 className="page-heading">We can’t schedule an in-home vaccine for you at this time.</h1>
                            <p className="subheading-info">Sorry, it happens. It could be due to a low availability in your area, the eligibility requirements changing, or even a hiccup in the internet. Please come back later and try again.</p>
                        </div>
                    </div>
                    <button className="btn btn-primary cta"
                        onClick={() => {
                            logUI(`MBHWeb.UI.InHomeInEligibility.BackToDashboard.Clicked`, new Date(), Tools.getURLPath());
                            let route = `/`;
                            history.push(route);
                        }}
                    >Back to Dashboard</button>
                </div>
            </div>
            <InHomeFaq />
            <div className="row">
                <div className="col-12 maxWidth-content">
                    <div className="row">
                        <div className="col-12">
                            <SchedulingQuestions />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        )
}

export default InHomeInEligibility